import React from "react";
import SEO from "@/components/SEO";
import LocationTemplate from "@/components/LocationTemplate";

const CoburgPage = () => <LocationTemplate suburbName="Coburg" suburbSlug="coburg" />;

export default CoburgPage;
